import { useState } from 'react';
import { MenuSelect } from '@components/MenuSelect';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const MenuSelectSection = () => {
  const [selectedMenuValue, setSelectedMenuValue] = useState<string | null>('la');
  const [selectedMenuNoSubtitle, setSelectedMenuNoSubtitle] = useState<string | null>('opt2');
  const [selectedMenuDisabled, setSelectedMenuDisabled] = useState<string | null>('active1');
  const [selectedMenuScrollable, setSelectedMenuScrollable] = useState<string | null>('3');
  const [selectedMenuFilterable, setSelectedMenuFilterable] = useState<string | null>(null);

  return (
    <section className={styles.section}>
      <SectionHeader
        title="Menu Select"
        description="A dropdown menu panel for selecting from a list of options. Composed of ListItem components with built-in scrolling support."
        figmaNodeId="281-2003"
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Interactive Menu</h3>
        <div className={styles.menuSelectContainer}>
          <MenuSelect
            items={[
              { value: 'la', label: 'Los Angeles (US)', subtitle: 'California' },
              { value: 'ny', label: 'New York (US)', subtitle: 'New York' },
              { value: 'chi', label: 'Chicago (US)', subtitle: 'Illinois' },
              { value: 'hou', label: 'Houston (US)', subtitle: 'Texas' },
            ]}
            value={selectedMenuValue}
            onChange={setSelectedMenuValue}
          />
        </div>
        <p className={styles.hint}>
          Selected: <strong>{selectedMenuValue || 'None'}</strong>
        </p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Without Subtitles</h3>
        <div className={styles.menuSelectContainer}>
          <MenuSelect
            items={[
              { value: 'opt1', label: 'Option 1' },
              { value: 'opt2', label: 'Option 2' },
              { value: 'opt3', label: 'Option 3' },
              { value: 'opt4', label: 'Option 4' },
            ]}
            value={selectedMenuNoSubtitle}
            onChange={setSelectedMenuNoSubtitle}
          />
        </div>
        <p className={styles.hint}>
          Selected: <strong>{selectedMenuNoSubtitle || 'None'}</strong>
        </p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>With Disabled Item</h3>
        <div className={styles.menuSelectContainer}>
          <MenuSelect
            items={[
              { value: 'active1', label: 'Active Option' },
              { value: 'active2', label: 'Another Active Option' },
              { value: 'disabled', label: 'Disabled Option', disabled: true },
              { value: 'active3', label: 'Third Active Option' },
            ]}
            value={selectedMenuDisabled}
            onChange={setSelectedMenuDisabled}
          />
        </div>
        <p className={styles.hint}>
          Selected: <strong>{selectedMenuDisabled || 'None'}</strong>
        </p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Scrollable (Max Height: 150px)</h3>
        <div className={styles.menuSelectContainer}>
          <MenuSelect
            items={[
              { value: '1', label: 'Item 1' },
              { value: '2', label: 'Item 2' },
              { value: '3', label: 'Item 3' },
              { value: '4', label: 'Item 4' },
              { value: '5', label: 'Item 5' },
              { value: '6', label: 'Item 6' },
              { value: '7', label: 'Item 7' },
              { value: '8', label: 'Item 8' },
            ]}
            value={selectedMenuScrollable}
            onChange={setSelectedMenuScrollable}
            maxHeight={150}
          />
        </div>
        <p className={styles.hint}>
          Selected: <strong>{selectedMenuScrollable || 'None'}</strong> - Scroll to see more items
        </p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Filterable</h3>
        <div className={styles.menuSelectContainer}>
          <MenuSelect
            items={[
              { value: 'la', label: 'Los Angeles (US)', subtitle: 'California' },
              { value: 'ny', label: 'New York (US)', subtitle: 'New York' },
              { value: 'chi', label: 'Chicago (US)', subtitle: 'Illinois' },
              { value: 'hou', label: 'Houston (US)', subtitle: 'Texas' },
              { value: 'phx', label: 'Phoenix (US)', subtitle: 'Arizona' },
              { value: 'phi', label: 'Philadelphia (US)', subtitle: 'Pennsylvania' },
              { value: 'sa', label: 'San Antonio (US)', subtitle: 'Texas' },
              { value: 'sd', label: 'San Diego (US)', subtitle: 'California' },
            ]}
            value={selectedMenuFilterable}
            onChange={setSelectedMenuFilterable}
            filterable
            maxHeight={200}
          />
        </div>
        <p className={styles.hint}>
          Selected: <strong>{selectedMenuFilterable || 'None'}</strong> - Type to filter items
        </p>
      </div>
    </section>
  );
};
